import { ValidationErrorResponse } from "../../../services/ValidationError";

export interface FormValue {
  wasTouched: boolean;
  isValid: boolean | undefined;
}

export interface TextFormValue extends FormValue {
  value: string;
}

export interface FormState {
  nombre: TextFormValue;
  descripcion: TextFormValue;
  precio: TextFormValue;
  sector: TextFormValue;
  pais: TextFormValue;
  departamento: TextFormValue;
  ciudad: TextFormValue;
  tipoTrayecto: TextFormValue;
}

export const initialFormState: FormState = {
  nombre: { value: "", wasTouched: false, isValid: undefined },
  descripcion: { value: "", wasTouched: false, isValid: undefined },
  precio: { value: "0", wasTouched: false, isValid: undefined },
  sector: { value: "", wasTouched: false, isValid: undefined },
  pais: { value: "", wasTouched: false, isValid: undefined },
  departamento: { value: "", wasTouched: false, isValid: undefined },
  ciudad: { value: "", wasTouched: false, isValid: undefined },
  tipoTrayecto: { value: "UN_TRAYECTO", wasTouched: false, isValid: undefined },
};

export const resetValidStates = (formState: FormState) => {
  Object.keys(formState).forEach((_key) => {
    const currentVal: FormValue = (formState as any)[_key] as FormValue;
    (formState as any)[_key] = { ...currentVal, isValid: undefined };
  });
};

export const invalidateStates = (
  formState: FormState,
  validationErrorResponse: ValidationErrorResponse
) => {
  Object.keys(validationErrorResponse).forEach((errKey) => {
    const errKeyStr = errKey as string;
    const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
    (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
  });
};
